export default "__VITE_ASSET__DrRWgJvr__"